// Stable public recipe imported by PageApplications. Apps can alias this module while
// importing the defaults directly to avoid a circular dependency.
export * from './applications.variants.defaults';
